export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.Zast_driver_guarantors) {
        return {...state, ...payload.Zast_driver_guarantors};
      }
      return state;
    }
  }
};
